import {ConfigService} from "@config/config.service";
import {createEntityAdapter, EntityAdapter, EntityState} from "@ngrx/entity";
import {PaginationModel} from "@shared/models/pagination.model";
import {CounterpartiesActions, CounterpartiesActionTypes} from '@billing/ngrx/actions/counterparty.actions';
import {BillingCounterpartyModel} from "@services/back-office/model/billingCounterpartyModel";
import {StringRequest} from "@services/back-office/model/stringRequest";

export const adapter: EntityAdapter<BillingCounterpartyModel> = createEntityAdapter<BillingCounterpartyModel>();

export interface State extends EntityState<BillingCounterpartyModel> {
    loading: boolean,
    pagination: PaginationModel,
    filter: StringRequest,
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: new ConfigService().paginationConfig.pageSize,
        totalElements: 0,
    },
    filter: {}
});

export function reducer(state = initialState, action: CounterpartiesActions): State {
    switch (action.type) {

        case CounterpartiesActionTypes.LoadCounterparties:
            return {...state, loading: !action.payload?.dontShowLoading};
        case CounterpartiesActionTypes.LoadCounterpartiesSuccess:
            return adapter.setAll(action.payload.content!, {
                ...state,
                loading: false,
                pagination: {
                    size: action.payload.size,
                    last: action.payload.last,
                    totalElements: action.payload.totalElements,
                    numberOfElements: action.payload.numberOfElements,
                    first: action.payload.first,
                    number: action.payload.number,
                },
            });

        case CounterpartiesActionTypes.LoadCounterpartiesFailure:
            return {...state, loading: false};

        case CounterpartiesActionTypes.AddCounterpartiesFailure:
            return {...state};

        case CounterpartiesActionTypes.EditCounterparties:
            return {...state};

        case CounterpartiesActionTypes.EditCounterpartiesSuccess:
        case CounterpartiesActionTypes.UpdateCounterpartySuccess:
            return adapter.updateOne({id: action.payload.id!, changes: action.payload}, {...state});

        case CounterpartiesActionTypes.DeleteCounterpartiesSuccess:
            return adapter.removeOne(action.payload, {
                ...state,
                pagination: {
                    ...state.pagination,
                    numberOfElements: state.pagination.numberOfElements !== 0 ? state.pagination.numberOfElements! - 1 : 0
                }
            });

        case CounterpartiesActionTypes.ChangePage:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    number: action.payload.number,
                    size: action.payload.size
                }
            };

        case CounterpartiesActionTypes.SetInitialPagination:
            return {...state, pagination: initialState.pagination};

        case CounterpartiesActionTypes.SetFilter:
            return {...state, filter: action.payload};

        case CounterpartiesActionTypes.ClearFilter:
            return {...initialState};

        default:
            return state;
    }
}

export const {
    selectIds: selectCounterpartiesIds,
    selectAll: selectAllCounterparties
} = adapter.getSelectors();
